import React from 'react'

import PropTypes from 'prop-types'
import Step from './Step'

import './ProgressTracker.less'

class ProgressTracker extends React.Component {
  render () {
    return (
      <div className='nmc-progress-tracker'>
        {
          React.Children.map(this.props.children,
            (child, i) => {
              const isSelected = this.props.selectedSteps.includes(child.props.stepId !== undefined ? child.props.stepId : i)
              return React.cloneElement(child, {
                selected: isSelected
              })
            })
        }
      </div>
    )
  }
}

ProgressTracker.propTypes = {
  selectedSteps: PropTypes.arrayOf(PropTypes.number)
}

ProgressTracker.defaultProps = {
  selectedSteps: []
}

ProgressTracker.Step = Step

export default ProgressTracker



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/ProgressTracker/index.js